export default "__VITE_ASSET__V2T2uv6l__"